export default __webpack_public_path__ + "static/media/2-1.99b96396.webp";